import { nextFrame } from 'derivita/util/promises/promise';

export class AsyncAnimationDelay {
  private promise_?: Promise<void>;

  constructor(private listener_: () => void) {}

  async start(): Promise<void> {
    this.promise_ = nextFrame();
    await this.promise_;
    this.run();
  }

  startIfNotActive(): Promise<void> {
    if (!this.promise_) {
      return this.start();
    }
    return this.promise_;
  }

  private run(): void {
    this.promise_ = undefined;
    this.listener_();
  }
}
